import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store/hooks';

const MAX_CHAR_LIMIT_ERR = 'Reduce number of characters ';
const RENDER_MODE_PREFIX = 'Switch to ';
const RENDER_MODE_ERR = 'Single Take ';
const EMPTY_CONTENT_ERR = 'Add script ';

const POSTFIX_ERR = 'to enable Cues';

export const CuesModeErrorText = ({ text }: { text?: string }) => {
  const isRenderModeErr = text === RENDER_MODE_ERR;
  return (
    (text && (
      <span>
        {isRenderModeErr && <span>{RENDER_MODE_PREFIX}</span>}
        <span style={{ fontWeight: 'bold' }}>{text}</span>
        <span>{POSTFIX_ERR}</span>
      </span>
    )) ||
    null
  );
};

/**
 * This hook gets the error messaging from the editor if
 * there are reasons we should disable the cues mode
 */
const useCuesModeError = (): {
  errorMessage?: string;
} => {
  const [singleErrorMessage, setSingleErrorMessage] = useState<string>();
  const editorState = useAppSelector(state => state.editor);
  const { error, renderMode, finalScript } = editorState;
  const { charactersUsed } = finalScript;

  /**
   * If any of the values we care about change, check if we should update the
   * error message or clear out the error message
   */
  useEffect(() => {
    let updated;
    if (error && error.message.includes('exceeded')) {
      updated = MAX_CHAR_LIMIT_ERR;
    }
    if (renderMode !== 'all') {
      updated = RENDER_MODE_ERR;
    }

    if (charactersUsed === 0) {
      updated = EMPTY_CONTENT_ERR;
    }

    setSingleErrorMessage(updated);
  }, [renderMode, charactersUsed, error]);

  return {
    errorMessage: singleErrorMessage,
  };
};

export default useCuesModeError;
